'use client';

import { CollapsibleCard } from '@/new_components/guv/CollapsibleCard';
import { MOBILE_ORDER } from './companyDetailLayout';
import { FlatAktivaFinancialTable } from '@/new_components/guv/FlatAktivaFinancialTable';
import { FlatPassivaFinancialTable } from '@/new_components/guv/FlatPassivaFinancialTable';
import { FlatFinancialTable } from '@/new_components/guv/FlatFinancialTable';
import type { FlatFinancialRow } from '@/new_components/guv/FlatFinancialTable';
import type { BalanceSheetFlatRow } from '@/new_components/balance_sheet/balanceSheetService';
import type { GuvFlatRow } from '@/new_components/guv/guvHistoryService';
import RawFinancialsCard from '@/new_components/raw_financials/RawFinancialsCard';
import type { TFunction } from 'i18next';

interface AdminFinancialTablesCardProps {
  t: TFunction;
  aktivaData: BalanceSheetFlatRow[] | null;
  passivaData: BalanceSheetFlatRow[] | null;
  guvData: GuvFlatRow[] | null;
  aiGuvData: GuvFlatRow[] | null;
  euId: string;
}

export function AdminFinancialTablesCard({
  t,
  aktivaData,
  passivaData,
  guvData,
  aiGuvData,
  euId,
}: AdminFinancialTablesCardProps) {
  return (
    <CollapsibleCard
      className={MOBILE_ORDER.adminFinancials}
      title={t(
        'companyDetail.detailedFinancialData',
        'Detailed Financial Data',
      )}
      defaultOpen={false}
    >
      <div className="p-4 space-y-4">
        {aktivaData && aktivaData.length > 0 && (
          <FlatAktivaFinancialTable
            data={aktivaData}
            title="AKTIVA Data"
            defaultOpen={false}
          />
        )}
        {passivaData && passivaData.length > 0 && (
          <FlatPassivaFinancialTable
            data={passivaData}
            title="PASSIVA Data"
            defaultOpen={false}
          />
        )}
        {guvData && guvData.length > 0 && (
          <FlatFinancialTable
            data={guvData as FlatFinancialRow[]}
            title="GUV Data"
            defaultOpen={false}
          />
        )}
        {aiGuvData && aiGuvData.length > 0 && (
          <FlatFinancialTable
            data={aiGuvData as FlatFinancialRow[]}
            title="AI GUV Data"
            defaultOpen={false}
          />
        )}
        <CollapsibleCard
          title="Raw Financial Data"
          defaultOpen={false}
        >
          <div className="p-0 overflow-auto">
            <RawFinancialsCard
              euId={euId}
              className="rounded-none border-0 shadow-none"
              showHeader={false}
              density="compact"
            />
          </div>
        </CollapsibleCard>
      </div>
    </CollapsibleCard>
  );
}
